import mutations from "./mutations.js"
import actions from "./actions.js"
import getters from "./getters.js"

export default {
  namespaced: true,
  state() {
    return {
      updateStatus: null,
      givenName: null,
      surname: null,
      organization: null,
    }
  },
  mutations,
  actions,
  getters,
}